// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EnrollmentV2IsValidMemberNumberModel } from './enrollmentV2IsValidMemberNumberModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class EnrollmentEnrollmentCheckMemberNumberDefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': EnrollmentV2IsValidMemberNumberModel | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EnrollmentEnrollmentCheckMemberNumberDefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "EnrollmentV2IsValidMemberNumberModel"
        },
    ];

    static getAttributeTypeMap() {
        return EnrollmentEnrollmentCheckMemberNumberDefaultResponse.attributeTypeMap;
    }
}
